import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap5';

import {
  Outlet,
} from 'react-router-dom';
import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import SessionsToSchedule from './SessionsToSchedule';
import NextSessions from './NextSessions';
import PastSessions from './PastSessions';

export default function Index() {
  const homeContext = useHomeContext();
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Schedule',
    },
  ];

  return (
    <div className="content" key={refreshKey}>
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <section>
        <h1>Schedule</h1>
      </section>

      <section>
        <NextSessions />
      </section>

      <Tab.Container
        id="sessions"
        defaultActiveKey="sessions-to-schedule"
      >
        <Nav fill justify variant="tabs" className="d-flex">
          <Nav.Item>
            <Nav.Link eventKey="sessions-to-schedule">
              Schedule New Sessions
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="past-sessions">
              Past Sessions
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="sessions-to-schedule" className="px-sm-4 px-xxl-5">
            <SessionsToSchedule refresh={refresh} />
          </Tab.Pane>

          <Tab.Pane eventKey="past-sessions" className="px-sm-4 px-xxl-5">
            <PastSessions />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      <Outlet />
    </div>
  );
}
